module.exports = __webpack_public_path__ + "static/media/2.6d4d96df.png";